<template>
	<LayoutBase>
		<header id="content__header">
			<h1>Here's what you've missed</h1>
		</header>

        <EventModal
            v-if="!this.$store.getters.registrationCompleted && this.$store.getters.eventLoading"
            :curr-event="this.$store.getters.event"
        />

		<div id="stats" class="grid">
			<div class="col-6 col-md-4 col-grid">
				<router-link :to="{ name: 'dashboard' }" class="card card--stat">
					<SvgIcon icon="dashboard-opportunities" class="card__icon" />
					<span>
						<strong>{{ counts.opportunities || '-' }}</strong>
						New Opportunities
					</span>
				</router-link>
			</div>
			<div class="col-6 col-md-4 col-grid">
				<router-link :to="{ name: 'dashboard', params: { tab: 'madds' } }" class="card card--stat" replace>
					<SvgIcon icon="dashboard-madds" class="card__icon" />
					<span>
						<strong>{{ counts.madds || '-' }}</strong>
						New MADDs
					</span>
				</router-link>
			</div>
<!--			<div class="col-6 col-md-3 col-grid">-->
<!--				<router-link :to="{ name: 'dashboard', params: { tab: 'intelligence' } }" class="card card&#45;&#45;stat" replace>-->
<!--					<SvgIcon icon="dashboard-intelligence" class="card__icon" />-->
<!--					<span>-->
<!--						<strong>{{ counts.intelligence || '-' }}</strong>-->
<!--						New Intelligence-->
<!--					</span>-->
<!--				</router-link>-->
<!--			</div>-->
			<div class="col-6 col-md-4 col-grid">
				<router-link :to="{ name: 'dashboard', params: { tab: 'insights' } }" class="card card--stat" replace>
					<SvgIcon icon="dashboard-insights" class="card__icon" />
					<span>
						<strong>{{ counts.insights || '-' }}</strong>
						New Insights
					</span>
				</router-link>
			</div>
		</div>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="opportunities" title="Opportunities">
				<ListOpportunities ref="opportunities" :load-on-start="false" :new-only="true" />
			</v-tab>
			<v-tab id="madds" title="MADDs">
				<ListMADDs ref="madds" :load-on-start="false" :new-only="true" />
			</v-tab>
<!--			<v-tab id="intelligence" title="Intelligence">-->
<!--				<ListIntelligence ref="intelligence" :load-on-start="false" :new-only="true" />-->
<!--			</v-tab>-->
			<v-tab id="insights" title="Insights">
				<ListInsights ref="insights" :load-on-start="false" :new-only="true" />
			</v-tab>
		</vue-tabs>
	</LayoutBase>
</template>

<script>
	import Vue from 'vue';
	import API from './../api';
	import LayoutBase from './Layout/LayoutBase';
	import ListOpportunities from './List/ListOpportunities';
	import ListMADDs from './List/ListMADDs';
	import ListIntelligence from './List/ListIntelligence';
    import EventModal from './Events/EventModal.vue';
	//import ListUsers from './List/ListUsers';
	import TabbedPage from './TabbedPage';
	import SvgIcon from './SvgIcon';
	import ListInsights from './List/ListInsights';

	export default {
		name: 'PageDashboard',
		mixins: [TabbedPage],
		components: {
			ListInsights,
			SvgIcon,
			//ListUsers,
			ListIntelligence,
			ListOpportunities,
			ListMADDs,
			LayoutBase,
            EventModal,
		},
		data() {
			return {
				counts: {
					opportunities: null,
					madds: null,
					intelligence: null,
					users: null,
				},
				defaultTab: 'opportunities',
				tabRoute: 'dashboard',
			}
		},
		methods: {
			refresh() {
				let id = this.currentTab;

				if(this.$refs[id] && this.$refs[id].load) {
					this.$refs[id].load();
				}
			}
		},
		created() {
			API.getDashboardCount().then(response => {
				Vue.set(this, 'counts', response);
			});

            API.getEvent().then(response => {
                //filtering events are storing the next event to occur
                let activeEvents = response.filter(event => Date.now() < event.signupEndDate);
                activeEvents = activeEvents.sort((a,b) => {return a.signupEndDate - b.signupEndDate});
                let nextEvent = activeEvents[0];

                this.$store.commit('modifyEvent', nextEvent);

                if(nextEvent){
                    API.isUserSubscribed(nextEvent.id).then(evResponse => {
                       console.log("is user subscribed: ", evResponse);

                       if(evResponse) {
                           this.$store.commit('modifyRegistrationComplete', true);
                       } else {
                           this.$store.commit('modifyRegistrationComplete',  false);
                       }

                        this.$store.commit('modifyEventLoading', true);
                    });
                }
            })
		},
	}
</script>

<style lang="scss" scoped>
	#stats {
		margin-bottom: 4rem;

		[class*=col-]{
			padding: 10px;
		}
	}
</style>
